import 'core-js/stable';

import 'regenerator-runtime/runtime';
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import VueCordova from 'vue-cordova'
import VueHead from 'vue-head'
import store from '@/store'
import App from './App'
import router from './router'
import ls from 'vue-ls'
import Vue2Filters from 'vue2-filters'
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader
import VueWait from 'vue-wait'

/* import custom css */
import './assets/css/fonts.css'
import './assets/css/custom.css'
import './assets/css/control.css'


import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import VChart from 'vue-echarts';
import { LegacyGridContainLabel } from 'echarts/features';

// Настройка ECharts
use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  BarChart,
  PieChart,
  GridComponent,
  CanvasRenderer,
  LegacyGridContainLabel,
])
Vue.component('v-chart', VChart);

Vue.use(Vuetify)
Vue.config.productionTip = false
Vue.use(VueCordova)
Vue.use(VueHead)
Vue.use(Vue2Filters)
Vue.use(VueLayers)
Vue.use(VueWait)

let lsOptions = {
  namespace: 'vuejs__',
  name: 'ls',
  storage: 'local',
}
Vue.use(ls, lsOptions)

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  created: function() {
    store.dispatch('globalDataUpdate') // обновляем все данные
  },
  router,
  store,
  wait: new VueWait({
    useVuex: true,
    vuexModuleName: 'wait',
    registerDirective: true,
    directiveName: 'wait',
    accessorName: '$l',
  }),
  template: '<App/>',
  components: { App },
  head: {
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover',
      },
    ],
  },
})
